import { render, staticRenderFns } from "./mainHome.vue?vue&type=template&id=5fbb2188&scoped=true&"
import script from "./mainHome.vue?vue&type=script&lang=js&"
export * from "./mainHome.vue?vue&type=script&lang=js&"
import style0 from "./mainHome.vue?vue&type=style&index=0&id=5fbb2188&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbb2188",
  null
  
)

export default component.exports